import { Alert, Snackbar } from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { hideToast } from "../../slices/global/ToastSlice";

const Toast: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { open, message, severity } = useSelector(
    (state: RootState) => state.toast
  );

  const handleClose = (
    event: Event | React.SyntheticEvent<any, Event>,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(hideToast({ message: "" }));
  };
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{
          width: "100%",
          color:
            severity === "error"
              ? "#C01048"
              : severity === "success"
              ? "#027A48"
              : "",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
